import { gql, useQuery } from "@apollo/client";
import React from "react";
import "./Dashboard.scss";
import { useNavigate } from "react-router-dom";
import RefreshIcon from "./RefreshIcon";
import { useDispatch } from "react-redux";

// GraphQL Query
const LIVE_DATA_QUERY = gql`
  query GetLiveLoadsTrucksShipments {
    LiveLoadsTrucksShipments
  }
`;

const LiveData = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleRedirect = (pageName, TabName) => {
    if (pageName) {
      navigate(`/${pageName}`);
      dispatch({ type: "TabData", payload: { tab: TabName } });
    } else {
      console.error("Page name is not defined for this entry");
    }
  };

  const handleCtrlClick = (event, pageName, TabName) => {
    if (event.ctrlKey) {
      handleRedirect(pageName);
      const Tabdata = {
        key: pageName,
        data: TabName,
      };
      dispatch({ type: "UNIQUE_TAB_SELECT", payload: Tabdata });
    }
  };

  const { data, loading, error, refetch } = useQuery(LIVE_DATA_QUERY, {
    context: { headers: { "X-GraphQL-Server": "secondary" } },
    notifyOnNetworkStatusChange: true,
  });

  const updatedData = data?.LiveLoadsTrucksShipments || [];

  if (error) {
    return <p className="error-message">Error: {error.message}</p>;
  }

  return (
    <div className="live-data-wrapper">
      <div className="load-post-title_With_Loading_Logo">
        <div className="load-post-title">Live Data</div>
        <div className="load-post-Loading_Logo">
          <RefreshIcon
            handleRefetch={refetch}
            loading={loading}
            className="icon_styling delete_icon_style FiRefreshCcw"
          />
        </div>
      </div>

      <div className="live-data-container">
        {updatedData.length > 0
          ? updatedData.map((item, index) =>
              Object.entries(item).map(([key, value]) => (
                <div
                  key={`${index}-${key}`}
                  className="live-data-box"
                  onClick={(event) => handleCtrlClick(event, value?.pageName, value?.TabName)}
                >
                  <div className="live-data-value">{value?.count}</div>
                  <div className="live-data-title">{key.replace(/_/g, " ")}</div>
                </div>
              ))
            )
          : !loading && <p className="no-data-message">No live data available</p>}
      </div>
    </div>
  );
};

export default LiveData;
